import Navbar from "../../components/Global/Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import novonordisk from "../../assets/brands/novo-nordisk-beskåret.png";
import backBtn from "../../assets/icons/back-btn.png";

export default function NovoNordisk() {
  const navigate = useNavigate();

  return (
    <div>
      <Navbar />
      <section className="bg-doctio-beige d-icon-full md:h-[calc(100vh-9rem)] pb-28 md:py-16">
        <div className="grid container mx-auto md:grid-cols-2">
          <div>
            <button
              className="flex items-center mb-8"
              onClick={() => navigate(-1)}
            >
              <img src={backBtn} width={26} className="mr-3" alt="Tilbage" />
              <p className="text-doctio-green">Tilbage</p>
            </button>

            <h1 className="text-doctio-green mb-10 font-bold text-dxl md:text-d4xl">
              Doctio er støttet af Novo Nordisk
            </h1>

            <p>
              Udviklingen fra Doctios webapplikation version 2.0 til Doctio Pro
              version 3.0 med klikelementer, notifikationsmenu og dele-funktion
              mellem brugerne, er støttet af Novo Nordisk.
            </p>

            <p className="mb-0">
              Disclaimer: I Doctio ApS ønsker vi fuld gennemsigtighed. Novo
              Nordisk har bidraget med økonomisk støtte til UI- og backend
              udvikling af Doctio Pro version 3.0 Alt indhold, fraser mm., er
              lavet af Doctio ApS eller vores frasekonsulenter.
            </p>
          </div>

          <div>
            <img
              src={novonordisk}
              alt="Novo Nordisk logo"
              className="opacity-30 w-11/12 mt-28 md:mt-0 md:w-9/12 mx-auto md:ml-auto"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
